import { Navigate, useRoutes } from 'react-router-dom';
import OwnNotFound from '../pages/OwnNotFound/OwnNotFound';
import OwnLayout from '../layout/OwnLayout';
import Dashboard from '../pages/Dashboard/Dashboard';
import Patients from '../pages/Patients/Patients';
import Practitioners from '../pages/Practitioners/Practitioners';
import Appointments from '../pages/Appointments/Appointments';
import Encounters from '../pages/Encounters/Encounters';
import Departments from '../pages/Departments/Departments';
import LabTests from '../pages/LabTests/LabTests';
import Items from '../pages/Items/Items';
import Login from '../pages/Auth/Login';
import ServiceUnits from '../pages/ServiceUnits/ServiceUnits';
import PatientAdd from '../components/upeosoft/PatientAdd/PatientAdd';
import PractitionerAdd from '../components/upeosoft/PractitionerAdd/PractitionerAdd';
import AppointmentAdd from '../components/upeosoft/AppointmentAdd/AppointmentAdd';
import EncounterAdd from '../components/upeosoft/EncounterAdd/EncounterAdd';
import LabTestAdd from '../components/upeosoft/LabTestAdd/LabTestAdd';
import ServicesPage from '../pages/ServicesPage/ServicesPage';
import Materials from '../pages/Materials/Materials';
import ItemAdd from '../components/upeosoft/ItemAdd/ItemAdd';
import PatientInsurancePolicy from '../pages/PatientInsurancePolicy/PatientInsurancePolicy';
import PatientInsurancePolicyAdd from '../components/upeosoft/PatientInsurancePolicyAdd/PatientInsurancePolicyAdd';
import EligibilityPlan from '../pages/EligibilityPlan/EligibilityPlan';
import PayorContract from '../pages/PayorContract/PayorContract';
import InsurancePayor from '../pages/InsurancePayor/InsurancePayor';
import InsurancePayorAdd from '../components/upeosoft/InsurancePayorAdd/InsurancePayorAdd';
import SalesInvoiceTable from '../pages/SalesInvoiceTable/SalesInvoiceTable';
import SalesInvoiceAdd from '../components/upeosoft/SalesInvoiceAdd/SalesInvoiceAdd';
import PaymentEntry from '../pages/PaymentEntry/PaymentEntry';
import PaymentEntryAdd from '../components/upeosoft/PaymentEntryAdd/PaymentEntryAdd';
import JournalEntry from '../pages/JournalEntry/JournalEntry';
import JournalEntryAdd from '../components/upeosoft/JournalEntryAdd/JournalEntryAdd';
import GeneralLedgerTable from '../pages/GeneralLedgerTable/GeneralLedgerTable';
import ChartAccountTable from '../pages/ChartAccountTable/ChartAccountTable';
import ModeOfPaymentsTable from '../pages/ModeOfPaymentsTable/ModeOfPaymentsTable';
import ModeOfPaymentAdd from '../components/upeosoft/ModeOfPaymentAdd/ModeOfPaymentAdd';
import FiscalYearTable from '../pages/FiscalYearTable/FiscalYearTable';
import ChartAccountAdd from '../components/upeosoft/ChartAccountAdd/ChartAccountAdd';
import Diagnosis from '../pages/Diagnosis/Diagnosis';
import { getStoredToken } from '../services/user-storage';
import AppointmentDuration from '../pages/AppointmentDuration/AppointmentDuration';
import Illness from '../pages/Illness/Illness';
import Bnpi from '../pages/Bnpi/Bnpi';
import CostCenter from '../pages/CostCenter/CostCenter';
import ItemEligibility from '../components/upeosoft/ItemEligibility/ItemEligibility';
import PatientCoverage from '../components/upeosoft/PatientCoverage/PatientCoverage';
import PatientCoverageAdd from '../components/upeosoft/PatientCoverageAdd/PatientCoverageAdd';
import InsuranceClaim from '../pages/InsuranceClaim/InsuranceClaim';
import InsuranceClaimAdd from '../components/upeosoft/InsuranceClaimAdd/InsuranceClaimAdd';
import Practitionerschedule from '../pages/Practitionerschedule/Practitionerschedule';
import Complaint from '../pages/Complaint/Complaint';
import Reconcillation from '../pages/Reconcillation/Reconcillation';
import CreditNotes from '../pages/CreditNotes/CreditNotes';
import BankAccount from '../pages/BankAccount/BankAccount';
import Bank from '../pages/Bank/Bank';
import CostCenterAllocation from '../pages/CostCenterAllocation/CostCenterAllocation';
import SupplierGroup from '../pages/SupplierGroup/SupplierGroup';
import Supplier from '../pages/Supplier/Supplier';
import Warehouse from '../pages/Warehouse/Warehouse';
import MaterialRequest from '../pages/MaterialRequest/MaterialRequest';
import ImageMapBody from '../components/common/ImageMapBody/ImageMapBody';
import PriceList from '../pages/PriceList/PriceList';
import UnitMeasure from '../pages/UnitMeasure/UnitMeasure';
import ItemPrice from '../pages/ItemPrice/ItemPrice';
import ItemList from '../pages/ItemList/ItemList';
import AddItemStock from '../components/upeosoft/AddItemStock/AddItemStock';
import AddMaterialRequest from '../components/upeosoft/AddMaterialRequest/AddMaterialRequest';
import PurchaseOrder from '../pages/PurchaseOrder/PurchaseOrder';
import AddPurchaseOrder from '../components/upeosoft/AddPurchaseOrder/AddPurchaseOrder';
import PurchaseReciept from '../pages/PurchaseReciept/PurchaseReciept';
import AddPurchaseReciept from '../components/upeosoft/AddPurchaseReciept/AddPurchaseReciept';
import PurchaseInvoice from '../pages/PurchaseInvoice/PurchaseInvoice';
import AddPurchaseInvoice from '../components/upeosoft/AddPurchaseInvoice/AddPurchaseInvoice';
import StockReconcillation from '../pages/StockReconcillation/StockReconcillation';
import AddStockReconcillation from '../components/upeosoft/AddStockReconcillation/AddStockReconcillation';
import StockEntry from '../pages/StockEntry/StockEntry';
import AddStockEntry from '../components/upeosoft/AddStockEntry/AddStockEntry';
import Employee from '../pages/Employee/Employee';
import AddEmployee from '../components/upeosoft/AddEmployee/AddEmployee';
import LeaveType from '../pages/LeaveType/LeaveType';
import LeaveTypeAdd from '../components/upeosoft/LeaveTypeAdd/LeaveTypeAdd';
import LeavePolicy from '../pages/LeavePolicy/LeavePolicy';
import LeaveAllocation from '../pages/LeaveAllocation/LeaveAllocation';
import AddLeaveAllocation from '../components/upeosoft/AddLeaveAllocation/AddLeaveAllocation';
import LeavePolicyAssign from '../pages/LeavePolicyAssign/LeavePolicyAssign';
import LeaveApplication from '../pages/LeaveApplication/LeaveApplication';
import AddLeaveApplication from '../components/upeosoft/AddLeaveApplication/LeaveApplication';
import HolidayList from '../pages/HolidayList/HolidayList';
import DebitNote from '../pages/DebitNote/DebitNote';
import ExpenseClaim from '../pages/ExpenseClaim/ExpenseClaim';
import LandedCostVoucher from '../pages/LandedCostVoucher/LandedCostVoucher';
import AddLandedCostVoucher from '../components/upeosoft/AddLandedCostVoucher/AddLandedCostVoucher';
import EmployeeAdvance from '../pages/EmployeeAdvance/EmployeeAdvance';
import AddEmployeeAdvance from '../components/upeosoft/AddEmployeeAdvance/AddEmployeeAdvance';
import AdditionalSalay from '../pages/AdditionalSalay/AdditionalSalay';
import AddAdditionalSalay from '../components/upeosoft/AddAdditionalSalay/AddAdditionalSalay';
import DepartmentHr from '../pages/DepartmentHr/DepartmentHr';
import AddDepartmentHr from '../components/upeosoft/AddDepartmentHr/AddDepartmentHr';
import DesignationHr from '../pages/DesignationHr/DesignationHr';
import BranchHr from '../pages/BranchHr/BranchHr';
import PurchaseReturn from '../pages/PurchaseReturn/PurchaseReturn';
import StockBalanceReport from '../pages/StockBalanceReport/StockBalanceReport';
import StockLedgerReport from '../pages/StockLedgerReport/StockLedgerReport';
import SalaryComponentHr from '../pages/SalaryComponentHr/SalaryComponentHr';
import AddSalaryComponentHr from '../components/upeosoft/AddSalaryComponentHr/AddSalaryComponentHr';
import SalaryStructureHr from '../pages/SalaryStructureHr/SalaryStructureHr';
import AddSalaryStructureHr from '../components/upeosoft/AddSalaryStructureHr/AddSalaryStructureHr';
import AddSalaryStructureAssignHr from '../components/upeosoft/AddSalaryStructureAssignHr/AddSalaryStructureAssignHr';
import SalaryStructureAssignHr from '../pages/SalaryStructureAssignHr/SalaryStructureAssignHr';
import GeneraledgerReport from '../pages/GeneraledgerReport/GeneraledgerReport';
import TrialBalance from '../pages/TrialBalance/TrialBalance';
import Profile from '../pages/Profile/Profile';
import EditProfile from '../components/upeosoft/EditProfile/EditProfile';
// import ExpenseClaimFinance from '../pages/ExpenseClaimFinance/ExpenseClaimFinance';
import AddExpenseClaimFinance from '../components/upeosoft/AddExpenseClaimFinance/AddExpenseClaimFinance';
import ExpenseClaimFinance from '../pages/ExpenseClaimFinance/ExpenseClaimFinance';
import SalarySlip from '../pages/SalarySlip/SalarySlip';
import AddSalarySlipHr from '../components/upeosoft/AddSalarySlipHr/AddSalarySlipHr';
import CustomerList from '../pages/Customer/Customer';
import AddCustomer from '../components/upeosoft/AddCustomer/AddCustomer';
import SalesOrder from '../pages/SalesOrder/SalesOrder';
import AddSalesOrder from '../components/upeosoft/AddSalesOrder/AddSalesOrder';
import Attandence from '../pages/Attandence/Attandence';
import AddAttandence from '../components/upeosoft/AddAttandence/AddAttandence';
import PayrollEntry from '../pages/PayrollEntry/PayrollEntry';
import AddPayrollEntry from '../components/upeosoft/AddPayrollEntry/AddPayrollEntry';
import AccountPeriod from '../pages/AccountPeriod/AccountPeriod';
import AddAccountPeriod from '../components/upeosoft/AddAccountPeriod/AddAccountPeriod';
import AccountReceivableSummary from '../pages/GeneraledgerReport/AccountReceivableSummary';
import AccountPayableSummary from '../pages/GeneraledgerReport/AccountPayableSummary';
import BalanceSheet from '../pages/GeneraledgerReport/BalanceSheet';
import ConsolidatedFinancialStatement from '../pages/GeneraledgerReport/ConsolidatedFinancialStatement';
import ProfitLoss from '../pages/TrialBalance/ProfitLoss';
import CashFlow from '../pages/TrialBalance/CashFlow';
import StatementOfAccount from '../pages/StatementOfAccount/StatementOfAccount';
import ItemGroup from '../pages/ItemGroup/ItemGroup';
import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { onMessageListener, requestForToken } from '../firebase';
import { queryKeys } from '../services/react-query/queryKeys';
import ItemPriceReport from '../pages/StockLedgerReport/ItemPriceReport';
import StockAnalysisReport from '../pages/StockLedgerReport/StockAnalysisReport';
import PurchaseAnalytics from '../pages/StockLedgerReport/PurchaseAnalytics';
import UserView from '../pages/UserView/UserView';
import TodoList from '../pages/TodoList/TodoList';
import Address from '../pages/Address/Address';
import ZatcaDetailsReport from '../pages/ZatcaDetailsReport/ZatcaDetailsReport';
import ZatcaSummaryReport from '../pages/ZatcaDetailsReport/ZatcaSummaryReport';
function RoutesWrapper({ t }) {
  const client = useQueryClient();

  useEffect(() => {
    if (getStoredToken()) {
      handelAddNotification();
    }
    onMessageListener((payload) => {
      console.log(payload, 'wwwwwwwwwwwwwwwww');
      client.invalidateQueries([queryKeys.getNotifications]);
    });
  }, []);

  const handelAddNotification = async () => {
    const userToken = await requestForToken();
    console.log('userToken', userToken);
    let body = {
      Token: userToken,
      OS: 3,
    };
    // addPushToken(body).then((res) => {
    //   console.log("res", res);
    // }).catch((err) => {
    //   console.log("err", err);
    // })
  };
  const routes = useRoutes([
    // {
    //   path: '*',
    //   element: <OwnNotFound t={t} />,
    // },
    {
      path: '/',
      element: getStoredToken()?.sid ? (
        <OwnLayout t={t} />
      ) : (
        <Navigate to="/login" />
      ),
      children: [
        {
          index: true,
          element: <Dashboard t={t} />,
        },
        {
          path: '*',
          element: <OwnNotFound t={t} />,
        },
        {
          path: '/patients',
          element: <Patients t={t} />,
        },
        {
          path: '/patients/add',
          element: <PatientAdd edit={false} t={t} />,
        },
        {
          path: '/patients/:id',
          element: <PatientAdd edit={true} t={t} />,
        },
        {
          path: '/practitioners',
          element: <Practitioners t={t} />,
        },
        {
          path: '/practitioners/add',
          element: <PractitionerAdd edit={false} t={t} />,
        },
        {
          path: '/practitioners/:id',
          element: <PractitionerAdd edit={true} t={t} />,
        },
        {
          path: '/appointments',
          element: <Appointments t={t} />,
        },
        {
          path: '/appointments/add',
          element: <AppointmentAdd edit={false} t={t} patient={false} />,
        },
        {
          path: '/appointments/patient/add/:id',
          element: <AppointmentAdd edit={false} t={t} patient={true} />,
        },
        {
          path: '/appointments/:id',
          element: <AppointmentAdd edit={true} t={t} patient={false} />,
        },
        {
          path: '/encounters',
          element: <Encounters t={t} />,
        },
        {
          path: '/encounters/add',
          element: <EncounterAdd edit={false} t={t} appointment={false} />,
        },
        {
          path: '/encounters/:id',
          element: <EncounterAdd edit={true} t={t} appointment={false} />,
        },
        {
          path: '/encounters/appointment/add/:idAppointment',
          element: <EncounterAdd edit={false} t={t} appointment={true} />,
        },
        {
          path: '/departments',
          element: <Departments t={t} />,
        },
        {
          path: '/practitioner-schedule',
          element: <Practitionerschedule t={t} />,
        },
        {
          path: '/service-units',
          element: <ServiceUnits t={t} />,
        },
        {
          path: '/lab-test',
          element: <LabTests t={t} />,
        },
        {
          path: '/lab-test/add',
          element: <LabTestAdd t={t} edit={false} />,
        },
        {
          path: '/lab-test/:id',
          element: <LabTestAdd t={t} edit={true} />,
        },
        {
          path: '/items',
          element: <Items t={t} />,
        },
        {
          path: '/item/add',
          element: <ItemAdd t={t} edit={false} services={false} />,
        },
        {
          path: '/item/:id',
          element: <ItemAdd t={t} edit={true} services={false} />,
        },
        {
          path: '/servicesPage',
          element: <ServicesPage t={t} services={true} />,
        },
        {
          path: '/service/add',
          element: <ItemAdd t={t} edit={false} services={true} />,
        },
        {
          path: '/service/:id',
          element: <ItemAdd t={t} edit={true} services={true} />,
        },
        {
          path: '/materials',
          element: <Materials t={t} />,
        },
        {
          path: '/patient_insurance_policy',
          element: <PatientInsurancePolicy t={t} />,
        },
        {
          path: '/item_eligibility',
          element: <ItemEligibility t={t} />,
        },
        {
          path: '/patient_coverage',
          element: <PatientCoverage t={t} />,
        },
        {
          path: '/patient_coverage/add',
          element: <PatientCoverageAdd edit={false} t={t} />,
        },
        {
          path: '/patient_coverage/edit/:id',
          element: <PatientCoverageAdd edit={true} t={t} />,
        },
        {
          path: '/patient_insurance_policy/add',
          element: <PatientInsurancePolicyAdd t={t} edit={false} />,
        },
        {
          path: '/patient_insurance_policy/edit/:id',
          element: <PatientInsurancePolicyAdd t={t} edit={true} />,
        },
        {
          path: '/insurance_payor_eligibility_plan',
          element: <EligibilityPlan t={t} />,
        },
        {
          path: '/insurance_payor_contracts',
          element: <PayorContract t={t} />,
        },
        {
          path: '/insurance_payors',
          element: <InsurancePayor t={t} />,
        },
        {
          path: '/insurance_payor/add',
          element: <InsurancePayorAdd edit={false} t={t} />,
        },
        {
          path: '/insurance_payor/:id',
          element: <InsurancePayorAdd edit={true} t={t} />,
        },
        {
          path: '/sales-invoice',
          element: <SalesInvoiceTable t={t} />,
        },
        {
          path: '/sales-invoice/add',
          element: <SalesInvoiceAdd edit={false} t={t} />,
        },
        {
          path: '/sales-invoice/:id',
          element: <SalesInvoiceAdd edit={true} t={t} />,
        },
        {
          path: '/sales-invoice-order/:idOrder',
          element: <SalesInvoiceAdd edit={false} t={t} />,
        },
        {
          path: '/sales-invoice-credit/:id',
          element: <SalesInvoiceAdd edit={true} t={t} credit={true} />,
        },
        {
          path: '/sales-invoice/edit/:id',
          element: <SalesInvoiceAdd edit={true} t={t} />,
        },
        {
          path: '/sales-order/sales-invoice/:idSalesOrder/:idAmount',
          element: <SalesInvoiceAdd edit={false} t={t} salesOrder={true} />,
        },
        {
          path: '/sales-order/sales-invoice-full-payment/:idFullPayment',
          element: (
            <SalesInvoiceAdd
              edit={false}
              t={t}
              salesOrder={false}
              SalesFullPayment={true}
            />
          ),
        },
        {
          path: '/payment-entry',
          element: <PaymentEntry t={t} payment={true} />,
        },
        {
          path: '/receipt-voucher',
          element: <PaymentEntry t={t} receipt={true} payment={false} />,
        },
        {
          path: '/Payment-Voucher',
          element: (
            <PaymentEntry
              t={t}
              receipt={false}
              stockPayment={true}
              payment={false}
            />
          ),
        },
        {
          path: '/payment-entry/:id',
          element: <PaymentEntryAdd edit={true} t={t} sales={false} />,
        },
        {
          path: '/payment-entry/sales/:id',
          element: <PaymentEntryAdd edit={false} t={t} sales={true} />,
        },
        {
          path: '/account-period',
          element: <AccountPeriod t={t} />,
        },
        {
          path: '/sales-order/payment-entry/:idSalesOrder',
          element: (
            <PaymentEntryAdd
              edit={false}
              t={t}
              sales={false}
              salesOrder={true}
            />
          ),
        },
        {
          path: '/payment-entry/purchase-invoice/:idPurchaseInvoice',
          element: (
            <PaymentEntryAdd edit={false} t={t} sales={false} invoice={true} />
          ),
        },
        {
          path: '/payment-entry/add',
          element: <PaymentEntryAdd edit={false} t={t} sales={false} />,
        },
        {
          path: '/employee-advance/payment/:idEmployeeAdvance',
          element: (
            <PaymentEntryAdd edit={false} t={t} sales={false} employee={true} />
          ),
        },
        {
          path: '/payment-entry-receipt-voucher/add',
          element: (
            <PaymentEntryAdd receipt={true} edit={false} t={t} sales={false} />
          ),
        },
        {
          path: '/journal-entry',
          element: <JournalEntry t={t} />,
        },
        {
          path: '/journal-entry/:id',
          element: <JournalEntryAdd edit={true} t={t} />,
        },
        {
          path: '/journal-entry/add',
          element: <JournalEntryAdd edit={false} t={t} />,
        },
        {
          path: '/generalledger',
          element: <GeneralLedgerTable t={t} />,
        },
        {
          path: '/accounts',
          element: <ChartAccountTable t={t} />,
        },
        {
          path: '/accounts/add',
          element: <ChartAccountAdd edit={false} t={t} />,
        },
        {
          path: '/accounts/:id',
          element: <ChartAccountAdd edit={true} t={t} />,
        },
        {
          path: '/modeofpayments',
          element: <ModeOfPaymentsTable t={t} />,
        },
        {
          path: '/modeofpayments/add',
          element: <ModeOfPaymentAdd edit={false} t={t} />,
        },
        {
          path: '/modeofpayments/:id',
          element: <ModeOfPaymentAdd edit={true} t={t} />,
        },
        {
          path: '/fiscalyear',
          element: <FiscalYearTable t={t} />,
        },
        {
          path: '/diagnosis',
          element: <Diagnosis t={t} />,
        },
        {
          path: '/AppointmentDuration',
          element: <AppointmentDuration t={t} />,
        },
        {
          path: '/illnesses',
          element: <Illness t={t} />,
        },
        {
          path: '/bnpi',
          element: <Bnpi t={t} />,
        },
        {
          path: '/costcenter',
          element: <CostCenter t={t} />,
        },
        {
          path: '/insurance_claim',
          element: <InsuranceClaim t={t} />,
        },
        {
          path: '/insurance_claim/add',
          element: <InsuranceClaimAdd t={t} edit={false} />,
        },
        {
          path: '/insurance_claim/:id',
          element: <InsuranceClaimAdd t={t} edit={true} />,
        },
        {
          path: '/Complaint',
          element: <Complaint t={t} />,
        },
        {
          path: '/reconcillation',
          element: <Reconcillation t={t} />,
        },
        {
          path: '/credit-notes',
          element: <CreditNotes t={t} />,
        },
        {
          path: '/bank',
          element: <Bank t={t} />,
        },
        {
          path: '/bank-account',
          element: <BankAccount t={t} />,
        },
        {
          path: '/cost-center-allocation',
          element: <CostCenterAllocation t={t} />,
        },
        {
          path: '/supplier-group',
          element: <SupplierGroup t={t} />,
        },
        {
          path: '/supplier',
          element: <Supplier t={t} />,
        },
        {
          path: '/warehouse',
          element: <Warehouse t={t} />,
        },
        {
          path: '/material-request',
          element: <MaterialRequest t={t} />,
        },
        {
          path: '/price-list',
          element: <PriceList t={t} />,
        },
        {
          path: '/item-list',
          element: <ItemList t={t} />,
        },
        {
          path: '/item-price',
          element: <ItemPrice t={t} />,
        },
        {
          path: '/unit-measure',
          element: <UnitMeasure t={t} />,
        },
        {
          path: '/add-material-request',
          element: <AddMaterialRequest t={t} edit={false} />,
        },
        {
          path: '/edit-material-request/:id',
          element: <AddMaterialRequest t={t} edit={true} />,
        },
        {
          path: '/sales-order/material-request/:idSalesOrder',
          element: <AddMaterialRequest t={t} edit={false} salesOrder={true} />,
        },
        {
          path: '/add-item-stock',
          element: <AddItemStock t={t} edit={false} />,
        },
        {
          path: '/edit-item-stock/:id',
          element: <AddItemStock t={t} edit={true} />,
        },
        {
          path: '/purchase-order',
          element: <PurchaseOrder t={t} />,
        },
        {
          path: '/purchase-order/add',
          element: <AddPurchaseOrder t={t} edit={false} order={false} />,
        },
        {
          path: '/purchase-order/edit/:id',
          element: <AddPurchaseOrder t={t} edit={true} order={false} />,
        },
        {
          path: '/add-purchase-order-material/:idOrder',
          element: <AddPurchaseOrder t={t} edit={false} order={true} />,
        },
        {
          path: '/image-body',
          element: <ImageMapBody t={t} />,
        },
        {
          path: '/purchase-return',
          element: <PurchaseReturn t={t} />,
        },
        {
          path: '/purchase-receipt',
          element: <PurchaseReciept t={t} />,
        },
        {
          path: '/purchase-reciept/add',
          element: <AddPurchaseReciept t={t} edit={false} />,
        },
        {
          path: '/purchase-reciept/show/:showReturnId',
          element: (
            <AddPurchaseReciept
              t={t}
              edit={false}
              show={false}
              showReturn={true}
            />
          ),
        },
        {
          path: '/purchase-reciept/edit/:id',
          element: <AddPurchaseReciept t={t} edit={true} />,
        },
        {
          path: '/purchase-reciept/return/:idReturn',
          element: <AddPurchaseReciept t={t} edit={false} show={true} />,
        },
        {
          path: '/purchase-order/add-receipt/:idOrder',
          element: <AddPurchaseReciept t={t} edit={false} order={true} />,
        },
        {
          path: '/debit-note',
          element: <DebitNote t={t} />,
        },
        {
          path: '/purchase-invoice',
          element: <PurchaseInvoice t={t} />,
        },
        {
          path: '/purchase-invoice/add',
          element: <AddPurchaseInvoice t={t} edit={false} />,
        },
        {
          path: '/purchase-invoice/edit/:id',
          element: <AddPurchaseInvoice t={t} edit={true} />,
        },
        {
          path: '/purchase-invoice/view/:idView',
          element: <AddPurchaseInvoice t={t} edit={false} view={true} />,
        },
        {
          path: '/purchase-invoice/add-debit-note/:idNote',
          element: <AddPurchaseInvoice t={t} edit={false} note={true} />,
        },
        {
          path: '/purchase-reciept/add-invoice/:idReciept',
          element: <AddPurchaseInvoice t={t} edit={false} reciept={true} />,
        },
        {
          path: '/purchase-order/add-invoice/:idOrder',
          element: (
            <AddPurchaseInvoice
              t={t}
              edit={false}
              reciept={false}
              order={true}
            />
          ),
        },
        {
          path: '/stock-reconcillation',
          element: <StockReconcillation t={t} />,
        },
        {
          path: '/stock-reconcillation/add',
          element: <AddStockReconcillation t={t} edit={false} />,
        },
        {
          path: '/stock-reconcillation/edit/:id',
          element: <AddStockReconcillation t={t} edit={true} />,
        },
        {
          path: '/stock-entry',
          element: <StockEntry t={t} />,
        },
        {
          path: '/stock-entry/add',
          element: <AddStockEntry t={t} edit={false} />,
        },
        {
          path: '/stock-entry/edit/:id',
          element: <AddStockEntry t={t} edit={true} />,
        },
        {
          path: '/material/stock-entry-add/:idMaterial',
          element: <AddStockEntry t={t} edit={false} material={true} />,
        },
        {
          path: '/employee',
          element: <Employee t={t} />,
        },
        {
          path: '/employee/add',
          element: <AddEmployee t={t} edit={false} />,
        },
        {
          path: '/employee/edit/:id',
          element: <AddEmployee t={t} edit={true} />,
        },
        {
          path: '/leave-type',
          element: <LeaveType t={t} />,
        },
        {
          path: '/leave-type/add',
          element: <LeaveTypeAdd t={t} edit={false} />,
        },
        {
          path: '/leave-type/edit/:id',
          element: <LeaveTypeAdd t={t} edit={true} />,
        },
        {
          path: '/leave-allocation',
          element: <LeaveAllocation t={t} />,
        },
        {
          path: '/leave-allocation/add',
          element: <AddLeaveAllocation t={t} edit={false} />,
        },
        {
          path: '/leave-allocation/edit/:id',
          element: <AddLeaveAllocation t={t} edit={true} />,
        },
        {
          path: '/leave-policy',
          element: <LeavePolicy t={t} />,
        },
        {
          path: '/leave-policy-assign',
          element: <LeavePolicyAssign t={t} />,
        },
        {
          path: '/leave-application',
          element: <LeaveApplication t={t} />,
        },
        {
          path: '/leave-application/add',
          element: <AddLeaveApplication t={t} edit={false} />,
        },
        {
          path: '/leave-application/edit/:id',
          element: <AddLeaveApplication t={t} edit={true} />,
        },
        {
          path: '/landed-cost-voucher',
          element: <LandedCostVoucher t={t} />,
        },
        {
          path: '/landed-cost-voucher/add',
          element: <AddLandedCostVoucher t={t} edit={false} />,
        },
        {
          path: '/landed-cost-voucher/edit/:id',
          element: <AddLandedCostVoucher t={t} edit={true} />,
        },
        {
          path: '/employee-advance',
          element: <EmployeeAdvance t={t} />,
        },
        {
          path: '/employee-advance/add',
          element: <AddEmployeeAdvance t={t} edit={false} />,
        },
        {
          path: '/employee-advance/edit/:id',
          element: <AddEmployeeAdvance t={t} edit={true} />,
        },
        {
          path: '/additional-salay',
          element: <AdditionalSalay t={t} />,
        },
        {
          path: '/employee-advance/salary-deduction/:idSalary',
          element: <AddAdditionalSalay t={t} employee={true} />,
        },
        {
          path: '/additional-salay/add',
          element: <AddAdditionalSalay t={t} edit={false} />,
        },
        {
          path: '/additional-salay/edit/:id',
          element: <AddAdditionalSalay t={t} edit={true} />,
        },
        {
          path: '/holiday-list',
          element: <HolidayList t={t} />,
        },
        {
          path: '/expense-claim-type',
          element: <ExpenseClaim t={t} />,
        },
        {
          path: '/department-hr',
          element: <DepartmentHr t={t} />,
        },
        {
          path: '/department-hr/add',
          element: <AddDepartmentHr t={t} edit={false} />,
        },
        {
          path: '/department-hr/edit/:id',
          element: <AddDepartmentHr t={t} edit={true} />,
        },
        {
          path: '/designation-hr',
          element: <DesignationHr t={t} />,
        },
        {
          path: '/Branch-hr',
          element: <BranchHr t={t} />,
        },
        {
          path: '/stock-balance-report',
          element: <StockBalanceReport t={t} />,
        },
        {
          path: '/stock-ledger-report',
          element: <StockLedgerReport edit={false} t={t} />,
        },
        {
          path: '/stock-ledger-report-reciept/:idReciept',
          element: <StockLedgerReport reciept={true} invoice={false} t={t} />,
        },
        {
          path: '/stock-ledger-report-credit-note/:idCreditNote',
          element: (
            <StockLedgerReport
              reciept={false}
              note={false}
              credit={true}
              invoice={false}
              t={t}
            />
          ),
        },
        {
          path: '/general-ledger-report-credit-note/:idCreditNote',
          element: (
            <GeneraledgerReport
              payment={false}
              journal={false}
              t={t}
              sales={false}
              note={false}
              credit={true}
              reciept={false}
              invoice={false}
            />
          ),
        },
        {
          path: '/accounts-receivable-summary',
          element: <AccountReceivableSummary t={t} />,
        },
        {
          path: '/accounts-payable-summary',
          element: <AccountPayableSummary t={t} />,
        },
        {
          path: '/balance-sheet',
          element: <BalanceSheet t={t} />,
        },
        {
          path: '/consolidated-financial-statement',
          element: <ConsolidatedFinancialStatement t={t} />,
        },
        {
          path: '/stock-ledger-report-debit-note/:idNote',
          element: (
            <StockLedgerReport
              reciept={false}
              note={true}
              invoice={false}
              t={t}
            />
          ),
        },
        {
          path: '/general-ledger-report-debit-note/:idNote',
          element: (
            <GeneraledgerReport
              payment={false}
              journal={false}
              t={t}
              note={true}
              sales={false}
              reciept={false}
              invoice={false}
            />
          ),
        },
        {
          path: '/stock-ledger-report-invoice/:idInvoice',
          element: <StockLedgerReport reciept={false} invoice={true} t={t} />,
        },
        {
          path: '/general-ledger-report',
          element: <GeneraledgerReport t={t} />,
        },
        {
          path: '/general-ledger-report-reciept/:idReciept',
          element: <GeneraledgerReport t={t} reciept={true} invoice={false} />,
        },
        {
          path: '/general-ledger-report-invoice/:idInvoice',
          element: <GeneraledgerReport t={t} reciept={false} invoice={true} />,
        },
        {
          path: '/general-ledger-report-sales/:idSales',
          element: (
            <GeneraledgerReport
              t={t}
              sales={true}
              reciept={false}
              invoice={false}
            />
          ),
        },
        {
          path: '/general-ledger-report-payment-entry/:idPayment',
          element: (
            <GeneraledgerReport
              payment={true}
              t={t}
              sales={false}
              reciept={false}
              invoice={false}
            />
          ),
        },
        {
          path: '/general-ledger-report-journal/:idJournal',
          element: (
            <GeneraledgerReport
              payment={false}
              journal={true}
              t={t}
              sales={false}
              reciept={false}
              invoice={false}
            />
          ),
        },
        {
          path: '/salary-component-hr',
          element: <SalaryComponentHr t={t} />,
        },
        {
          path: '/salary-component-hr/add',
          element: <AddSalaryComponentHr t={t} edit={false} />,
        },
        {
          path: '/salary-component-hr/edit/:id',
          element: <AddSalaryComponentHr t={t} edit={true} />,
        },
        {
          path: '/salary-structure-hr',
          element: <SalaryStructureHr t={t} />,
        },
        {
          path: '/salary-structure-hr/add',
          element: <AddSalaryStructureHr t={t} edit={false} />,
        },
        {
          path: '/salary-structure-hr/edit/:id',
          element: <AddSalaryStructureHr t={t} edit={true} />,
        },
        {
          path: '/salary-structure-assign-hr',
          element: <SalaryStructureAssignHr t={t} />,
        },
        {
          path: '/salary-structure-assign-hr/add',
          element: <AddSalaryStructureAssignHr t={t} edit={false} />,
        },
        {
          path: '/salary-structure-assign-hr/edit/:id',
          element: <AddSalaryStructureAssignHr t={t} edit={true} />,
        },
        {
          path: '/Trial-Balance',
          element: <TrialBalance t={t} />,
        },
        {
          path: '/cash-flow',
          element: <CashFlow t={t} />,
        },
        {
          path: '/profit-loss',
          element: <ProfitLoss t={t} />,
        },
        {
          path: '/Profile',
          element: <Profile t={t} />,
        },
        {
          path: '/Profile/:id',
          element: <EditProfile t={t} />,
        },
        {
          path: '/expense-claim',
          element: <ExpenseClaimFinance t={t} />,
        },
        {
          path: '/expense-claim/add',
          element: <AddExpenseClaimFinance edit={false} t={t} />,
        },
        {
          path: '/expense-claim/edit/:id',
          element: <AddExpenseClaimFinance edit={true} t={t} />,
        },
        {
          path: '/salary-slip-hr',
          element: <SalarySlip t={t} />,
        },
        {
          path: '/salary-slip-hr/add',
          element: <AddSalarySlipHr edit={false} t={t} />,
        },
        {
          path: '/salary-slip-hr/edit/:id',
          element: <AddSalarySlipHr edit={true} t={t} />,
        },
        {
          path: '/customers',
          element: <CustomerList t={t} />,
        },
        {
          path: '/customers/add',
          element: <AddCustomer edit={false} t={t} />,
        },
        {
          path: '/customers/edit/:id',
          element: <AddCustomer edit={true} t={t} />,
        },
        {
          path: '/account-period/add',
          element: <AddAccountPeriod edit={false} t={t} />,
        },
        {
          path: '/account-period/edit/:id',
          element: <AddAccountPeriod edit={true} t={t} />,
        },
        {
          path: '/sales-order',
          element: <SalesOrder t={t} />,
        },
        {
          path: '/sales-order/add',
          element: <AddSalesOrder edit={false} t={t} />,
        },
        {
          path: '/sales-order/edit/:id',
          element: <AddSalesOrder edit={true} t={t} />,
        },
        {
          path: '/attandence',
          element: <Attandence t={t} />,
        },
        {
          path: '/attandence/add',
          element: <AddAttandence edit={false} t={t} />,
        },
        {
          path: '/attandence/edit/:id',
          element: <AddAttandence edit={true} t={t} />,
        },
        {
          path: '/payroll-entry-hr',
          element: <PayrollEntry t={t} />,
        },
        {
          path: '/payroll-entry/add',
          element: <AddPayrollEntry edit={false} t={t} />,
        },
        {
          path: '/payroll-entry/edit/:id',
          element: <AddPayrollEntry edit={true} t={t} />,
        },
        {
          path: '/statement-of-account',
          element: <StatementOfAccount t={t} />,
        },
        {
          path: '/item-group',
          element: <ItemGroup t={t} />,
        },
        {
          path: '/item-price-report',
          element: <ItemPriceReport t={t} />,
        },
        {
          path: '/stock-analysis-report',
          element: <StockAnalysisReport t={t} />,
        },
        {
          path: '/purchase-analytics-report',
          element: <PurchaseAnalytics t={t} />,
        },
        {
          path: '/profile-user',
          element: <UserView t={t} />,
        },
        {
          path: '/todo-list',
          element: <TodoList t={t} />,
        },
        {
          path: '/address',
          element: <Address t={t} />,
        },
        {
          path: '/Zatca-Details-Report',
          element: <ZatcaDetailsReport t={t} />,
        },
        {
          path: '/Zatca-Summary-Report',
          element: <ZatcaSummaryReport t={t} />,
        },
      ],
    },
    {
      path: '/login',
      element: <Login t={t} />,
    },
  ]);
  return routes;
}

export default RoutesWrapper;
